export default [
  ['q', 'w', 'e', 'r', 't', 'z', 'u', 'i', 'o', 'p', 'ü'],
  ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'ö', 'ä'],
  ['y', 'x', 'c', 'v', 'b', 'n', 'm'],
];



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/keyboard/layouts/GermanLayout.jsx